import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { Division, ProductType } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get and save productType data.
 */
@Injectable()
export class ProductTypeService {
    public static INCLUDE_VERIFICATIONS: string = 'verifications';
    private cachedMap: { [apiRequest: string]: ProductType[]; } = {};

    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all productTypes
     */
    public getIndex(
        eventId: string,
        includes: string[] = null,
        queryParams: string[] = [],
        forceRefresh: boolean = false,
    ): Observable<ProductType[]> {
        const apiRequestUrl: string = this.getApiUrl(eventId, null, includes, queryParams);

        if (!forceRefresh && this.cachedMap[apiRequestUrl]) {
            // if cache is available just return it as `Observable`
            return observableInSeparateThread(
                this.cachedMap[apiRequestUrl].map((p: ProductType) => p.clone()),
            );
        }
        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const bodyData: any = response.data || [];
                const productTypes: ProductType[] = bodyData.map(
                    (item: any) => (new ProductType()).deserialize(item, response.included),
                );

                this.cachedMap[apiRequestUrl] = productTypes.map((d: ProductType) => d.clone());

                return productTypes;
            }));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(
        eventId: string,
        productTypeId: string,
        includes: string[],
        queryParams: string[] = null,
    ): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/product-types/`;

        if (productTypeId) {
            url += productTypeId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
